import React from "react";
import { CssBaseline, MuiThemeProvider } from "@material-ui/core";
import { ErrorBoundary } from "./presentation/ErrorBoundary/ErrorBoundary";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import { Layout } from "./presentation/Layout";
import { ErrorRenderer, ShellProps } from "./ModuleProps";
import { theme } from "./presentation/theme";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import enGBLocale from "date-fns/locale/en-GB";
import { configureStore } from "./redux/configureStore";
import { CookieConsent } from "./presentation/CookieConsent";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import "../styles/BaseStyle.scss";

export const Shell: React.FC<ShellProps> = (props) => {
  const { layout: PropsLayout, ...coreProps } = props;
  const history = createBrowserHistory();
  const store = configureStore(props, history);

  // .Root css className is currently required for the Complaints Module styling to work
  return (
    <div className="Root">
      <Helmet>
        <title>The Portal</title>

        <meta
          name="description"
          content="The Portal web application for Ofqual and Awarding Organisations."
        />
        <meta
          name="author"
          content="The Office of Qualifications and Examinations Regulation (Ofqual)"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="charset" content="utf-8" />

        <base href="/" />

        <link
          rel="shortcut icon"
          type="image/png/ico"
          href="images/favicon.ico"
        />
      </Helmet>
      {/* <CookieConsent /> */}
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enGBLocale}>
          <Provider store={store}>
            <ErrorBoundary
              errorRenderers={[
                ...findErrorRenderers([props.auth]),
                ...findErrorRenderers(props.items),
                ...findErrorRenderers(props.coreItems),
                ...findErrorRenderers(props.toolbarItems),
              ]}
            >
              <Router history={history}>
                <props.auth.module.component>
                  {PropsLayout ? (
                    <PropsLayout {...coreProps} />
                  ) : (
                    <Layout {...coreProps} />
                  )}
                </props.auth.module.component>
              </Router>
            </ErrorBoundary>
          </Provider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </div>
  );
};

const findErrorRenderers = (
  items?: {
    module?: { errorRenderer?: ErrorRenderer };
  }[]
) => {
  return (items || [])
    .filter((item) => item.module)
    .map((item) => item.module?.errorRenderer)
    .filter((errorRenderer) => !!errorRenderer) as ErrorRenderer[];
};
